import React from "react";
import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";
import ListWrapper from "../../../common/management/ListWrapper";
import ListContentWrapper from "../../../common/management/ListContentWrapper";
import ReleaseFacilityList from "../../management-jikei/release-list/ReleaseFacilityList";
import { genDisplayCount } from "../../../utils/GeneralUtils";
import { useGetFacilityAdmin } from "../../../utils/useFacility";
import { PageVisibility } from "../../../utils/PageVisibility";

type Props = {
  currentPage: number;
  perView: number;
};

const ReleaseFacilityListContainer: React.FC<Props> = ({
  currentPage,
  perView,
}) => {
  const authToken = useAppSelector(getAuthToken);

  const {
    items: { facilities, totalEntries: entries, totalPage },
    isLoading,
  } = useGetFacilityAdmin({
    authToken,
    page: currentPage,
    per: perView,
    status: PageVisibility.AwaitingInspection,
  });

  return (
    <ListWrapper pageTitle="施設公開申請">
      <ListContentWrapper
        isLoading={isLoading}
        displayCount={genDisplayCount(currentPage, totalPage, perView, entries)}
        totalEntries={entries}
        currentPage={currentPage}
        totalPage={totalPage}
      >
        <ReleaseFacilityList facilities={facilities} />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default ReleaseFacilityListContainer;
